/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Link} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "jspdf-autotable";
import ajaxCard from "../../../util/remote/ajaxCard";
import Pagination from "../../../Components/Common/Pagination";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import SchoolContext from "../../../Context/SchoolContext";
import AssignCard from "../../../Components/Students/AssignCard";
import useStateCallback from "../../../util/customHooks/useStateCallback";

function PendingAttachments() {
  const { schoolDetails } = useContext(SchoolContext);
  const [modal, setModal] = useStateCallback(false);

  const [studentList, setStudentList] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState("");
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState("");

  const getStudentList = async () => {
    setStudentList([]);
    setLoading(true);
    const server_response = await ajaxCard.fetchActivatedStudentsWithoutCardList(
      page, schoolDetails.school_id,
      
    );
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setStudentList(server_response.details.data || []);
    } else {
      setStudentList([]);
    }
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const assignCard = async (e, item) => {
    setModal(false, () =>
      setModal(
        <AssignCard
          studentID={item.student_id}
          fullName={item.user}
          g={getStudentList}
          isOpen={true}
        />
      )
    );
  };

  useEffect(() => {
    getStudentList();
  }, [page, schoolDetails.school_id]);

  return (
    <AppContainer title="Pending Attachments">
      <Toaster position="top-center" reverseOrder={false} />
        {modal}
      <div className="row">
        <div className="col-lg-12">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                <TableHeader
                  title="Pending Cards / Wristbands Attachments"
                  subtitle="List of all the activated students without assigned cards/wristbands"
                />
                <div class="dropdown">
                  <Link
                    class="dropdown-toggle"
                    role="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    ...
                  </Link>

                  <div class="dropdown-menu dropdown-menu-right">
                    <Link class="dropdown-item" onClick={getStudentList}>
                      <i class="fas fa-redo-alt text-orange-peel"></i>Refresh
                    </Link>
                  </div>
                </div>
              </div>
              <div className="border-top mt-3"></div>
              <div className="table-responsive">
                {loading ? (
                  <Loader />
                ) : (
                  <table className="table display data-table text-nowrap">
                    <thead>
                      <tr>
                      <th scope="col" className="wd-10p">
                        No.
                      </th>
                      <th scope="col">Student Name</th>
                      <th scope="col">Class</th>
                      <th scope="col">Activation Date</th>
                      <th scope="col">Activated By</th>

                      <th scope="col">Student to Receive</th>
                      <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                      {studentList.length > 0 ? (
                        studentList.map((item, index) => (
                          <tr key={index}>
                            <th scope='row' style={{width:"5px"}}>{index + first + 1}</th>
                                <td><Link to={`/school-students/profile/${item.student_id}/${item.user_id}`}>
                                {item.user}
                              </Link></td>
                                <td>{item.student_group}</td>
                                <td>{item.activation_date?.short_date}</td>
                                <td>{item.activated_by}</td>
                                <td>
                                  {item.card_status === "LOST" ? (
                                    <span className="badge badge-danger">LOST CARD</span>
                                  ) : item.activation_type === "4" ? (
                                    <span className="badge badge-info">CARD</span>
                                  ) : item.activation_type === "12" ? (
                                    <span className="badge badge-wb">WRISTBAND</span>
                                  ) : (
                                    <span className="badge badge-warning">IN REVIEW</span>
                                  )}
                                </td>

                                <td>
                                {(item.card_status !== "LOST" &&
                                  (item.activation_type === "4" || item.activation_type === "12")) && (
                                    <Link
                                      className="btn btn-primary"
                                      onClick={(e) => assignCard(e, item)}
                                    >
                                      <i className="fa-solid fa-plus" /> Attach{" "}
                                      {item.activation_type === "4" ? "Card" : "Wristband"}
                                    </Link>
                                )}
                                </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center" }}>
                            No pending attachments.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
               
             
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default PendingAttachments;
